import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import { build as buildEpic } from "../one-epics/index";
import { createEpicMiddleware } from "redux-observable";
import { reducer as voice } from "one-state-interact-voice";
import { reducer as userstate } from "one-state-interact-user";

import { reducer as hotkeys } from "one-state-hotkeys";

import { upcomingappointments } from "one-state-upcoming-appointments";
import { callingdest } from "one-state-calldest";
import { pendingbills } from "one-state-pending-bills";
import { pendingbillscerner } from "one-state-pendingbills-cerner";
import { sources } from "one-state-source-local";
import { sourcetype } from "one-state-source-type";
import { subjectstate } from "one-state-subject";
import { pcpstate } from "one-state-pcp";
import { patientpharmacy } from "one-state-patient-pharmacy";
import { pendingreferals } from "one-state-pending-referrals";
import { additionalinfo } from "one-state-patient-additional-info";
import { activetab } from "one-state-tabs";
import { screenpopstate } from "one-state-screenpop";
import { patientdrawer } from "one-state-patient-drawer";
import { addnew } from "one-state-addnew";
import { appointments } from "one-state-appointments";
import { allergiesstate } from "one-state-activeallergies";
import { activeproblems } from "one-state-activeproblems";
import { medicalhistory } from "one-state-medicalhistory";
import { patientglobalsearch } from "one-state-patient-global-search";
import { sourcesearch } from "one-state-sourcesearch";
import { patientverified } from "one-state-patient-verify";
import { patientMatch } from "one-state-patient-match";
import { providerglobalsearch } from "one-state-provider-global-search";
import { errorstate } from "one-state-error";
import { skeleton } from "one-state-skeleton";
import { choosecaller } from "one-state-choosecaller";
import { billingdetails } from "one-state-billing-details";
import { billingdetailscerner } from "one-state-billing-details-cerner";
import { insurancedetails } from "one-state-insurance";
import { prescription } from "one-state-prescription";
import { medicationstate } from "one-state-medication";
import { orderstable } from "one-state-orderstab";
import { errorhandle } from "one-state-errorhandle";
import { five9Interaction } from "one-state-interact-five9";
import { ccpInteraction } from "one-state-interact-ccp";
import { five9Store } from "one-state-interact-five9";
import {
  five9Notification,
  five9CallVariables,
  five9LogoutCodes,
  five9UserState,
} from "one-state-interact-five9";
import { five9ClickToDial } from "one-state-interact-five9";
import { fhirinsurancedetails } from "one-state-fhirinsurance/src/reducer";
import { identifierstate } from "one-state-patientidentifiers";
import { receivecommunicationstate } from 'one-state-receive-communication';
import { getuseridstate } from 'one-state-getuserid';
import { updateuseridstate } from 'one-state-updateuserid';
import { dispositionstate } from 'one-state-hotkeys';
import { customerdetailstate } from 'one-state-servicenow-verify/src/reducer';
import { incidents } from 'one-state-incidents/src/reducer'
import { interactions } from 'one-state-interactions/src/reducer';
import { createinteractionstate } from 'one-state-createinteractions/src/reducer';
import { createincidentstate } from 'one-state-createincidents/src/reducer';
import { linkincidentstate } from 'one-state-linkincidents/src/reducer';
import { updateincidentstate } from 'one-state-updateincidents/src/reducer';
import { modalvaluetstate } from 'one-state-modalvalue/src/reducer';
import { btgpatientsearch } from 'one-state-btgpatient/src/reducer';
import { subjecterror } from 'one-state-subjecterror/src/reducer';
import { wxccInteraction } from 'one-state-interact-wxcc';
import {
  vonageNotification,
  vonageCallVariables,
  vonageLogoutCodes,
  vonageUserState,
  vonageStore,
  vonageInteraction,
  vonageClickToDial,
  vonageAgentId
} from "one-state-interact-vonage";
import { setsessions } from 'one-state-setsession/src/reducer';
import { getsessionstate } from 'one-state-getsession/src/reducer'; 
import { endsession } from 'one-state-endsession/src/reducer';
import { subjectselectedreducer } from "one-state-subjectselected/src/reducer";
import { selectedsourcereducer } from 'one-state-sourceselected/src/reducer';
import { conversationreducer } from "one-state-genesysinteraction/src/reducer";
import { genesysagentreducer} from "one-state-genesysagent/src/reducer";
import {getproviderathstate } from "one-state-getproviderinfo-ath/src/reducer";
import { getdeptathstate} from 'one-state-getdeptinfo-ath/src/reducer';
import {apptreasoncode} from 'one-state-apptreasoncode/src/reducer';
import { notesHistory } from 'one-state-notes-history/src/reducer';
import { callHistory } from "one-state-call-history";
import { panvivauseridstate } from 'one-state-panvivauser/src/reducer';
import { panvivastate } from 'one-state-panviva/src/reducer';

//ring central
import {ringCentralLogin} from 'one-state-ringcentral-login/src/reducer';
import {ringCentralCallData} from 'one-state-ringcentral-calldata/src/reducer';
import {ringCentralAgentData} from 'one-state-ringcentral-agentName/src/reducer'
import { updatefive9state } from "one-state-five9_info/src/reducer"
import {ringCentralClickTocall} from 'one-state-ringcentral-clicktocall/src/reducer';
import { getpanvivaidstate } from 'one-state-getpanvivaid/src/reducer';
import { updatepanvivaidstate } from 'one-state-updatepanvivaid/src/reducer';
import { refillstate } from 'one-state-prescriptionrefills/src/reducer';
import { getstatementnumber } from 'one-state-getstatementnumber';
import {headlesswxccstate } from 'one-state-headless-wxcc/src/reducer';

const epicMiddleware = createEpicMiddleware();

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/**
 * Build the application store
 * Refer to redux documentatio for more details
 *
 * @param context - references to settings, logger etc.
 */
//TODO: make store type safe.
export const build = (context: any) => {
  const store = createStore(
    combineReducers({
      voice: voice(context),
      userstate: userstate(context),
      dispositionstate: dispositionstate(context),
      hotkeys: hotkeys(context),
      upappointments: upcomingappointments(context),
      pendingbill: pendingbills(context),
      sources: sources(context),
      sourcetype: sourcetype(context),
      subjectstore: subjectstate(context),
      calledentity: callingdest(context),
      pendingreferals: pendingreferals(context),
      pcpstate: pcpstate(context),
      pharmacy: patientpharmacy(context),
      addinfo: additionalinfo(context),
      activetab: activetab(context),
      screenpopstate: screenpopstate(context),
      patientdrawer: patientdrawer(context),
      addnew: addnew(context),
      appointments: appointments(context),
      allergiesstate: allergiesstate(context),
      activeproblems: activeproblems(context),
      medicalhistory: medicalhistory(context),
      patientglobalsearch: patientglobalsearch(context),
      //Logic Changed
      patientverify: patientverified(context),
      patientMatch: patientMatch(context),
      providerglobalsearch: providerglobalsearch(context),
      errorstate: errorstate(context),
      skeleton: skeleton(context),
      choosecaller: choosecaller(context),
      billingdetails: billingdetails(context),
      insurancedetails: insurancedetails(context),
      prescription: prescription(context),
      medicationdata: medicationstate(context),
      orderstabledata: orderstable(context),
      errormonitor: errorhandle(context),
      five9Interaction: five9Interaction(context),
      five9ClickToDial: five9ClickToDial(context),
      five9Store: five9Store(context),
      five9Notification: five9Notification(context),
      five9UserState: five9UserState(context),
      ccpInteraction: ccpInteraction(context),
      patientidentifier: identifierstate(context),
      fhirdetails: fhirinsurancedetails(context),
      sourcesearchdata: sourcesearch(context),
      five9CallVariables: five9CallVariables(context),
      five9LogoutCodes: five9LogoutCodes(context),
      receivecommunicationstate: receivecommunicationstate(context),
      epicuserid: getuseridstate(context),
      updateuserdata: updateuseridstate(context),
      servicenowcaller: customerdetailstate(context),
      getincidents: incidents(context),
      getinteractions: interactions(context),
      createinteraction: createinteractionstate(context),
      createincident: createincidentstate(context),
      linkedincident: linkincidentstate(context),
      updateincident: updateincidentstate(context),
      incidentmodalvalue: modalvaluetstate(context),
      bgtpatient: btgpatientsearch(context),
      patientlookuperror: subjecterror(context),
      wxccInteraction: wxccInteraction(context),
      vonageNotification:vonageNotification(context),
      vonageCallVariables:vonageCallVariables(context),
      vonageLogoutCodes:vonageLogoutCodes(context),
      vonageUserState:vonageUserState(context),
      vonageStore:vonageStore(context),
      vonageInteraction:vonageInteraction(context),
      vonageClickToDial:vonageClickToDial(context),
      vonageAgentId:vonageAgentId(context),
      setsessionreducer: setsessions(context),
      getsessionreducer: getsessionstate(context),
      postendsession: endsession(context),
      selectedsourceinfo: selectedsourcereducer(context),
      selectedsubjectinfo: subjectselectedreducer(context),
      interactioninfo: conversationreducer(context),
      genesysagentinfo: genesysagentreducer(context),
      apptreasoncode: apptreasoncode(context),
      five9callinfo: updatefive9state(context),
      // providerinforeducer: getproviderathstate(context),  // should remove
      // departmentinforeducer: getdeptathstate(context),    // should remove
      notesHistory: notesHistory(context),
      callHistory: callHistory(context),
      panvivauser: panvivastate(context),
      panvivasearch: getpanvivaidstate(context),
      updatepanvivadata: updatepanvivaidstate(context),
      ringCentralLogin:ringCentralLogin(context),
      ringCentralCallData:ringCentralCallData(context),
      ringCentralAgentData:ringCentralAgentData(context),
      ringCentralClickTocall:ringCentralClickTocall(context),
      presrefill: refillstate(context),
      statementnumberModal: getstatementnumber(context),
      billingdetailscerner:billingdetailscerner(context),
      pendingbillscerner:pendingbillscerner(context),
      headlesswxccstate: headlesswxccstate(context),

    }),
    composeEnhancer(applyMiddleware(epicMiddleware))
  );

  epicMiddleware.run(buildEpic(context));
  return store;
};
